<template>
  <section class="critical-health-insurance-section">
    <DynamicCalculator :data="data" />
  </section>
</template>

<script>
import DynamicCalculator from "./DynamicCalculator.vue";

export default {
  props: ["contentData"],
  components: {
    DynamicCalculator
  },
  data() {
    return {
      data: {
        axiosLink: "getCalcCriticalillness",
        formType: "critical",
        header: _.get(this.contentData, "conf.header")
      }
    };
  }
};
</script>
<style lang="scss">
.critical-health-insurance-section {
  .dynamic-calculator {
    &__form {
      .input-grid {
        display: grid;
        column-gap: 30px;
        margin-right: 30px;
        grid-template-columns: repeat(4, minmax(0px, 1fr));
        @media (max-width: 1023px) {
          grid-template-columns: repeat(2, minmax(0px, 1fr));
        }
        @media (max-width: 767px) {
          grid-template-columns: repeat(1, minmax(0px, 1fr));
          margin-right: 0px;
        }
      }
      @media (max-width: 1023px) {
        flex-direction: column;
      }
    }
  }
}
</style>
